<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :disable-sort="true"
      hide-default-footer
      :dense="dense"
    >
      <template v-slot:item="slotProps">
        <slot name="row" v-bind="slotProps" />
      </template>
    </v-data-table>
    <Pagination
      v-if="!totalItems || totalItems > 10"
      v-model="page"
      :loading="loading"
      :total="total"
      :page="page"
      @input="$emit('pageChange', $event)"
    />
  </div>
</template>

<script>
import Pagination from "./Pagination.vue";
export default {
  name: "DataTableWithPagination",
  components: { Pagination },
  props: {
    headers: Array,
    items: Array,
    loading: Boolean,
    page: Number,
    total: Number,
    totalItems: Number,
    dense: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
